import { KeyValueDefault } from '@/main/models/common';
import { KeyValueDefaultEnum } from '@/main/models/common/keyValueDefaultEnum';
import { CountryPublicResponse } from '@/main/models/response';

export enum CountryTypes {
  GET_COUNTRIES_USER = '@country/GET_COUNTRIES_USER',
  GET_COUNTRIES_PUBLIC = '@country/GET_COUNTRIES_PUBLIC',
  SAVE_COUNTRIES_PUBLIC = '@country/SAVE_COUNTRIES_PUBLIC',
  SAVE_COUNTRIES_USER = '@country/SAVE_COUNTRIES_USER',
  RESET_REDUCER_COUNTRIES_USER = '@country/RESET_REDUCER_COUNTRIES_USER'
}

export interface CountryState {
  readonly countriesUser: {
    data: KeyValueDefaultEnum[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly countriesPublic: {
    data: CountryPublicResponse[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetCountriesUser {
  type: typeof CountryTypes.GET_COUNTRIES_USER;
  payload: {
    idUser: string | null;
  };
}
export interface GetCountriesPublic {
  type: typeof CountryTypes.GET_COUNTRIES_PUBLIC;
}

export interface SaveCountriesUser {
  type: typeof CountryTypes.SAVE_COUNTRIES_USER;
  payload: {
    data: KeyValueDefault[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface SaveCountriesPublic {
  type: typeof CountryTypes.SAVE_COUNTRIES_PUBLIC;
  payload: {
    data: CountryPublicResponse[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerCountriesUser {
  type: typeof CountryTypes.RESET_REDUCER_COUNTRIES_USER;
}

export type CountryActionTypes =
  | GetCountriesUser
  | SaveCountriesUser
  | ResetReducerCountriesUser
  | GetCountriesPublic
  | SaveCountriesPublic;

